import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

interface UseCampaignHrefProps {
  requestPath: string
}

/**
 * Generates a dynamic href either including or excluding the campaign code in the URL depending on
 * whether the campaign code is present in the URL.
 *
 * @param requestPath - The path to append to the href
 * @returns The href with or without the campaign code
 */
const useCampaignHref = ({ requestPath }: UseCampaignHrefProps) => {
  const params = useParams<{ program: string; campaign?: string }>()

  const href = useMemo(() => {
    const p = params.program
    const c = params.campaign

    if (c) {
      return `/${p}/${c}/${requestPath}`
    }

    return `/${p}/${requestPath}`
  }, [params, requestPath])

  return { href }
}

export default useCampaignHref
